import React, { useState } from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DeleteKeys, hashtagHighlighter } from '../../../../../actions/appsMoreAction';
import { TOAST_DISMISS, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS } from '../../../../../utils';
import { useDispatch } from 'react-redux';
import { closePricingModal } from '../../../../../utils/close_modal';
import { refreshThemes } from '../../../../../actions/firstRunAction';
import CheckBoxField from '../../Feeds/AddFeeds/Elements/CheckboxField';
import ColorPicker from '../../../../CommonComponents/ColorPicker';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';

export default function HashtagHighlighter(props) {

  const { themeSetting, getThemeSetting } = props;

  const { hashtag_color, hashtag_feed, hashtag_all, hashtag_highlight } = getThemeSetting
  const hashtagData = props.hashtagHighlighter;
  const backgroundColor = getThemeSetting.hashtag_background_color
  const enableBackground = getThemeSetting.hashtag_background_status
  const signageTheme = hashtagData?.signageTheme

  const value = { feedHastag: hashtag_feed, allFeedHashtag: hashtag_all };
  const [spinner, setspinner] = useState(false);
  const dispatch = useDispatch();

  const data = { hashtag_color: hashtag_color, hashtag_background_color: backgroundColor, hashtag_feed: String(value.feedHastag), hashtag_all: String(value.allFeedHashtag), hashtag_background_status: String(enableBackground), hashtag_highlight: String(hashtag_highlight) }

  const onSubmitData = () => {
    setspinner(true)
    TOAST_LOADING();
    hashtagHighlighter(data).then(() => {
      DeleteKeys()
      TOAST_DISMISS()
      TOAST_SUCCESS('Hashtag Highlighter saved successfully.');
      props.activeSetting(0);
      setspinner(false);
      dispatch(refreshThemes());
      closePricingModal(dispatch);
    }).catch(() => {
      TOAST_DISMISS()
      TOAST_ERROR();
      setspinner(false)
    });
  }

  const applyChanges = (status) => {
    const { showDiscardPop } = props;
    showDiscardPop(onSubmitData, 'highlight', status);
  }

  return (
    <div className={`col-lg-${[21, 37, 35, 36, 44].includes(signageTheme) ? 12 : 12} col-md-12 col-sm-12 col-xs-12 cardProperties darkLabel`}>
      <div className="overflow-list">
        <div className="hashtagHighlighter_wrap hashcolor">
          <div className="pb-3">
            <label className="card-label font-weight-bolder text-dark">Hashtag Highlighter</label>
          </div>

          <div className="form-group">
            <div className="f-between">
              <div className='col-9'>
                <span>Feed Hashtags
                  <OverlayTrigger overlay={<Tooltip>Applicable when the feed name aligns with the hashtag name.</Tooltip>}>
                    <span className="ms-1">
                      <FontAwesomeIcon type={'solid'} icon={'circle-info'} iconClass={'text-gray-500'} />
                    </span>
                  </OverlayTrigger>
                </span>
              </div>
              <div className='col-3'>
                <div className="toggleOnBut">
                  <span className="switch float-end"><label htmlFor="wallHashtagFeed">
                    <input type="hidden" name="data[Personalization][hashtag_feed]" id="wallHashtagFeed_" value="0" />
                    <CheckBoxField isChecked={hashtag_feed} onChangeHandler={(e) => themeSetting({ hashtag_feed: Number(!hashtag_feed) })} name={`hashtag_feed`} id={`hashtag_feed`} text={0} />
                  </label></span>
                </div>
              </div>

            </div>
          </div>

          <div className="form-group">
            <div className="d-flex align-items-center justify-content-between">
              <div className='col-9'>
                <span>All Hashtags</span>
              </div>
              <div className='col-3'>
                <div className="toggleOnBut">
                  <span className="switch float-end"><label htmlFor="wallHashtagAll"><input type="hidden" name="data[Personalization][hashtag_all]" id="wallHashtagAll_" value="0" />
                    <CheckBoxField isChecked={hashtag_all} onChangeHandler={(e) => themeSetting({ hashtag_all: Number(!hashtag_all) })} name={`wallHashtagAll`} id={`wallHashtagAll`} text={0} />
                  </label></span>
                </div>
              </div>
            </div>
          </div>

          <div className="color-popup form-group">
            <label className="control-label mb-2">Color</label>
            <ColorPicker id='hashtagColor' defaultColor={hashtag_color} changeColor={(clr) => themeSetting({ hashtag_color: clr })} />
          </div>
        </div>
      </div>
      <div className="form-actions px-3 pt-3">
        <div className="card-toolbar d-flex align-items-center justify-content-end w-100">
          <Button onClick={() => applyChanges(0)} variant="secondary" className="w-50 me-2">Back</Button>
          <Button disabled={spinner ? true : false} onClick={() => applyChanges(1)} variant="dark" className={`w-50 me-2 ${spinner ? `spinner spinner-white spinner-right disabled` : null}`}>Save</Button>
          <OverlayTrigger placement="top" overlay={<Tooltip>Help</Tooltip>}>
            <a href="https://vimeo.com/545390391/106bae2c88"
              className="lity_lightbox vid_play_btn"
              data-support="https://taggbox.com/support/how-to-add-banner-in-your-taggbox-widget/"
              data-lity>
              <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={''} />
            </a>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}


